export const INITIAL_FRIENDLY_ID = 100010;
export const PRICE_PER_TON_IN_CENT = 9900; // 99.00
export const MINIMUM_WEIGHT_IN_TONS = 2;
export const DEFAULT_RENTAL_DAYS = 7;
